import { defineMessages } from 'react-intl';

export default defineMessages({
    upload: {
        id: '_.ui.upload_button',
        defaultMessage: 'Upload'
    }
});
